import React from 'react';

const MenuHeader = ({title}) => {
	return (
		<div className='menuHeaderTitleWrapper'>
			{title}
		</div>
	);
}
export default MenuHeader;